import type { AppLang } from '../detectLang';
import { zhPages } from './pages.zh';

export type PagesMessages = {
  common: {
    cancel: string;
    save: string;
    view: string;
    loading: string;
    delete: string;
    edit: string;
    refresh: string;
    close: string;
    all: string;
    newest: string;
    oldest: string;
    newestShort: string;
    oldestShort: string;
    fromDate: string;
    toDate: string;
    sortBy: string;
    updating: string;
    saving: string;
    update: string;
    create: string;
    add: string;
    copy: string;
    purgedOldGalleries: string;
  };
  mPhotoPro: {
    title: string;
    subtitle: string;
    noAccess: string;
    tabs: { photos: string; customFrames: string; customFramesShort: string; themes: string; themesShort: string; collections: string; icons: string; stats: string };
  };
  colorApps: {
    title: string;
    titleAll: string;
    titleMachine: string;
    description: string;
    descriptionAll: string;
    descriptionMachine: string;
    hexLabel: string;
    pickColor: string;
    hexHelper: string;
    apply: string;
    presets: string;
    derivedPalette: string;
    preview: string;
    primaryBtn: string;
    secondaryBtn: string;
    badgeChip: string;
    loadError: string;
    saveSuccess: string;
    saveSuccessAll: string;
    saveSuccessMachine: string;
    saveError: string;
    invalidHex: string;
    slots: {
      bg: string;
      surface: string;
      border: string;
      soft: string;
      primary: string;
      hover: string;
      text: string;
    };
  };
  photoboothSimple: {
    title: string;
    titleMachine: string;
    descriptionMachine: string;
    toggleLabel: string;
    toggleOnHint: string;
    toggleOffHint: string;
    maxAccessLabel: string;
    maxAccessHint: string;
    maxAccessSaveSuccess: string;
    captureIdleLabel: string;
    captureIdleHint: string;
    previewIdleLabel: string;
    previewIdleHint: string;
    retakeToggleLabel: string;
    retakeToggleHint: string;
    retakeEnableSuccess: string;
    retakeDisableSuccess: string;
    idleTimeoutSaveSuccess: string;
    idleTimeoutUnit: string;
    captureCountdownLabel: string;
    captureCountdownHint: string;
    captureCountdownUnit: string;
    captureCountdownSaveSuccess: string;
    captureCountdownOffline: string;
    lastUpdated: string;
    loadError: string;
    enableSuccess: string;
    disableSuccess: string;
    saveError: string;
    missingMachine: string;
    accessCodeTitle: string;
    accessCodeHint: string;
    accessCodeUpdated: string;
    sessionInUse: string;
    qrTitle: string;
    qrHint: string;
    copyLink: string;
    openLink: string;
  };
  mPhotoLite: {
    title: string;
    subtitle: string;
    tabs: { gallery: string; customFrames: string; customFramesShort: string; themes: string; themesShort: string; icons: string; stats: string };
    galleryEmpty: string;
    iconsDisabled: string;
  };
  mPhotoMono: {
    title: string;
    tabs: { subPhotos: string; frames: string; photos: string; stats: string };
    dropActive: string;
    dropIdle: string;
    photosHint: string;
    totalFiltered: string;
    total: string;
    photoCount: string;
    endOfList: string;
    emptyFiltered: string;
    empty: string;
  };
  photos: {
    viewTabs: { groups: string; list: string; collections: string };
    selectAll: string;
    downloadSelected: string;
    downloading: string;
    addToCollection: string;
    dropActive: string;
    dropIdle: string;
    maxFiles: string;
    uploadCta: string;
    filterByDate: string;
    filterByDevice: string;
    allDevices: string;
    clearFilter: string;
  };
  customFrames: {
    titlePro: string;
    titleLite: string;
    titleMono: string;
    hintPro: string;
    hintLite: string;
    emptyGranted: string;
    emptyEnabled: string;
    filterSize: string;
    viewUserFrames: string;
    toggleOn: string;
    toggleOff: string;
  };
  livePhotos: {
    title: string;
    loginRequired: string;
    emptyCollections: string;
    selectCollection: string;
    emptyGallery: string;
    galleryLabel: string;
    uploadedAt: string;
    collectionListTitle: string;
    galleryListTitle: string;
  };
  videos: {
    title: string;
    dropActive: string;
    dropIdle: string;
    maxOne: string;
    created: string;
  };
  sePay: {
    title: string;
    subtitle: string;
    tabs: { config: string; price: string; device: string };
    webhookTitle: string;
    webhookHint: string;
    receivingAccount: string;
    linked: string;
    noAccount: string;
    tapToConfig: string;
    saveKeysHeading: string;
    apiTokenLabel: string;
    priceLabel: string;
    savePrice: string;
    clearInput: string;
    deviceHeading: string;
    deviceHint: string;
    liteRequireQr: string;
    proRequireQr: string;
    createQrTitle: string;
    amount: string;
    description: string;
    bank: string;
    va: string;
    passwordDialog: string;
    qrDialog: string;
  };
  events: {
    title: string;
    createNew: string;
    empty: string;
    code: string;
    dialogCreate: string;
    dialogUpdate: string;
    nameLabel: string;
    namePlaceholder: string;
    submitCreate: string;
    submitUpdate: string;
    confirmDelete: string;
  };
  profile: {
    title: string;
    loading: string;
    changeBackground: string;
    changeAvatar: string;
    basicInfo: string;
    username: string;
    email: string;
    passwordSection: string;
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
    submit: string;
    submitting: string;
  };
  themes: {
    title: string;
    createNew: string;
    customFrameList: string;
    proShowAllTitle: string;
    proShowAllHint: string;
    emptyTitle: string;
    emptyHint: string;
    emptyHintLite: string;
    active: string;
    inactive: string;
    activeMliteLabel: string;
    mobileUploadProTitle: string;
    mobileUploadProHint: string;
    mobileUploadLiteTitle: string;
    mobileUploadLiteHint: string;
    mobileUploadOtherStatus: string;
    scheduleOpen: string;
    scheduleTitle: string;
    scheduleHint: string;
    scheduleEnable: string;
    scheduleFrom: string;
    scheduleUntil: string;
    machineFilterEnable: string;
    machineFilterEnableLite: string;
    machineFilterSelectAll: string;
    machineFilterClearAll: string;
    machineFilterHint: string;
    machineFilterHintLite: string;
    machineFilterNeedFrame: string;
    machineFilterEmpty: string;
    machineFilterEmptyLite: string;
    machineFilterLoading: string;
    machineFilterButton: string;
    machineFilterSaved: string;
    machineFilterSaveFail: string;
    scheduleAlways: string;
    scheduleAllMachines: string;
    scheduleNoMachines: string;
    scheduleMachineCount: string;
    scheduleOutside: string;
    dialogCreate: string;
    dialogEdit: string;
    name: string;
    description: string;
    tags: string;
    imageOptional: string;
    dropImage: string;
    imageFormats: string;
    breadcrumb: string;
    noDescription: string;
    metaCounts: string;
    addCustomFrame: string;
    framesInTheme: string;
    emptyFramesTitle: string;
    emptyFramesHint: string;
    addDialogTitle: string;
    addDialogHint: string;
    addDialogHintLite: string;
    noLiteFrames: string;
    pickUserFramesTitle: string;
    pickUserFramesHint: string;
    pickUserFramesUpload: string;
    pickUserFramesUploadHint: string;
    pickUserFramesUploading: string;
    pickUserFramesEmpty: string;
    pickUserFramesAdd: string;
    pickUserFramesAddFrame: string;
    searchPlaceholder: string;
    filterByRatio: string;
    noProFrames: string;
    allAddedOrFiltered: string;
    notFound: string;
  };
  customerInfo: {
    title: string;
    subtitle: string;
    settingTitle: string;
    enabled: string;
    disabled: string;
    listTitle: string;
    export: string;
    empty: string;
    endMessage: string;
    colImage: string;
    colEmail: string;
    colName: string;
    colActions: string;
    noImage: string;
    editDialog: string;
    confirmDelete: string;
  };
  software: {
    title: string;
    latestVersion: string;
    fileName: string;
    fileSize: string;
    uploadDate: string;
    download: string;
    noUpdate: string;
    updateInfo: string;
  };
  aiCreate: {
    title: string;
    subtitle: string;
    disabled: string;
    createTheme: string;
    viewUsage: string;
    usageTheme: string;
    usageBackground: string;
    editTheme: string;
    themeName: string;
    description: string;
    themeImage: string;
    noThemes: string;
    backgrounds: string;
    backgroundCount: string;
    emptyBackgrounds: string;
    createBackground: string;
    editBackground: string;
    backgroundName: string;
    prompt: string;
    tags: string;
    tagMale: string;
    tagFemale: string;
    tagGroup: string;
    tagsRequired: string;
    image: string;
    referenceImage: string;
    referenceHint: string;
    removeReference: string;
    proEnable: string;
    proHint: string;
    liteEnable: string;
    liteHint: string;
    machineHint: string;
    noMachines: string;
    back: string;
    save: string;
    cancel: string;
    delete: string;
    confirmDeleteTheme: string;
    confirmDeleteBackground: string;
  };
  deviceMgmt: {
    title: string;
    subtitle: string;
    emptyTitle: string;
    emptyHint: string;
    machineCode: string;
    running: string;
    paused: string;
    platformWindows: string;
    platformAndroid: string;
    productLite: string;
    productMono: string;
    productPro: string;
    noQrFeatures: string;
    viewAccess: string;
    renameTitle: string;
    renameSuccess: string;
    deleteTitle: string;
    deleteConfirm: string;
    deleteSuccess: string;
    nameLabel: string;
    namePlaceholder: string;
    back: string;
    backShort: string;
    tabs: {
      upload: string;
      uploadShort: string;
      control: string;
      controlShort: string;
      photos: string;
      photosShort: string;
      edit: string;
      editShort: string;
      colorApps: string;
      colorAppsShort: string;
      photobooth: string;
      photoboothShort: string;
      qrEdit: string;
      qrEditShort: string;
    };
    qrEditor: {
      title: string;
      hint: string;
      frame: string;
      layoutDefault: string;
      userFrames: string;
      offsetX: string;
      offsetY: string;
      size: string;
      step: string;
      showQr: string;
      lastEdited: string;
      saveSuccess: string;
      saveError: string;
      loadError: string;
      reset: string;
    };
    photosFilteredBy: string;
    photosEmptyTitle: string;
    photosEmptyHint: string;
    photosEnd: string;
    photosLoadError: string;
    photosNoLink: string;
    photosDeleteTitle: string;
    photosDeleteConfirm: string;
    photosDeleteSuccess: string;
    photosDeleteError: string;
    machineCodeLabel: string;
    randomCodeTitle: string;
    randomCodeHint: string;
    lastUpdated: string;
    qrUploadTitle: string;
    qrUploadHint: string;
    fullCode: string;
    copyLink: string;
    openNewTab: string;
    controlQrTitle: string;
    controlQrHint: string;
    editQrTitle: string;
    editQrHint: string;
    link: string;
    notFound: string;
    limitTitle: string;
    limitHint: string;
    accessLabel: string;
    accessHint: string;
    printCopiesLabel: string;
    printCopiesHint: string;
    uiEnabledTitle: string;
    uiEnabledHint: string;
    uiEnabledOn: string;
    uiEnabledOff: string;
    uiEnabledSaveSuccess: string;
    uiEnabledSaveError: string;
    uiEnabledLoadError: string;
    controlUiTitle: string;
    controlUiHint: string;
    controlUiSaveSuccess: string;
    controlUiSaveError: string;
    controlUiLoadError: string;
    bgRemovalTitle: string;
    bgRemovalHint: string;
    bgRemovalSaveSuccess: string;
    bgRemovalSaveError: string;
    bgRemovalLoadError: string;
    limitLoadError: string;
    limitSaveSuccess: string;
    limitSaveError: string;
    accessInvalid: string;
    printCopiesInvalid: string;
    restartApp: string;
    shutdownApp: string;
    restartConfirmTitle: string;
    restartConfirmBody: string;
    shutdownConfirmTitle: string;
    shutdownConfirmBody: string;
    restartSent: string;
    shutdownSent: string;
    appOfflineCantRemote: string;
    confirmAction: string;
  };
  icons: {
    dropActive: string;
    dropIdle: string;
    hint: string;
  };
};

const en: PagesMessages = {
  common: {
    cancel: 'Cancel',
    save: 'Save',
    view: 'View',
    loading: 'Loading...',
    delete: 'Delete',
    edit: 'Edit',
    refresh: 'Refresh',
    close: 'Close',
    all: 'All',
    newest: 'Newest',
    oldest: 'Oldest',
    newestShort: 'New',
    oldestShort: 'Old',
    fromDate: 'From date',
    toDate: 'To date',
    sortBy: 'Sort by',
    updating: 'Updating...',
    saving: 'Saving...',
    update: 'Update',
    create: 'Create',
    add: 'Add',
    copy: 'Copy',
    purgedOldGalleries: 'Removed {n} galleries older than 1 year',
  },
  mPhotoPro: {
    title: 'M-Photo Pro',
    subtitle: 'Gallery & custom frames for the Pro desktop app',
    noAccess: 'This account does not have access to M-Photo Pro.',
    tabs: { photos: 'Photos', customFrames: 'Custom Frame', customFramesShort: 'Frame', themes: 'Themes', themesShort: 'Theme', collections: 'Collections', icons: 'Icons', stats: 'Stats' },
  },
  colorApps: {
    title: 'Color Apps',
    titleAll: 'Color Apps — all devices',
    titleMachine: 'Color Apps — this device',
    description:
      'Pick a primary color — the app uses a light palette (background, border, soft…) like the color picker on the machine.',
    descriptionAll:
      'Change the app accent color for every device in this account. You can still set a different color per machine in that machine’s Color Apps tab.',
    descriptionMachine:
      'Change the app accent color for this device only. Other machines in the account keep their own color.',
    hexLabel: 'Color code (hex)',
    pickColor: 'Pick color',
    hexHelper: 'Example: #d45d7f — press Enter or Apply to save',
    apply: 'Apply',
    presets: 'Suggested colors',
    derivedPalette: 'App color palette (Derived palette)',
    preview: 'UI preview',
    primaryBtn: 'Primary button',
    secondaryBtn: 'Secondary button',
    badgeChip: 'Badge / chip',
    loadError: 'Could not load app color',
    saveSuccess: 'App color saved',
    saveSuccessAll: 'App color saved for all devices',
    saveSuccessMachine: 'App color saved for this device',
    saveError: 'Failed to save color',
    invalidHex: 'Invalid color code (#RRGGBB)',
    slots: {
      bg: 'Bg',
      surface: 'Surface',
      border: 'Border',
      soft: 'Soft',
      primary: 'Primary',
      hover: 'Hover',
      text: 'Text',
    },
  },
  photoboothSimple: {
    title: 'Photobooth',
    titleMachine: 'Photobooth',
    descriptionMachine: 'Turn on to show a capture QR on this machine.',
    toggleLabel: 'Simple mode',
    toggleOnHint: 'On',
    toggleOffHint: 'Off',
    maxAccessLabel: 'Prints / day',
    maxAccessHint: '0 = unlimited',
    maxAccessSaveSuccess: 'Daily device limit updated',
    captureIdleLabel: 'Capture idle timeout',
    captureIdleHint: 'Auto return to home if idle on the capture screen (1–10 minutes)',
    previewIdleLabel: 'Preview idle timeout',
    previewIdleHint: 'Auto-print / return home if idle on the preview screen (1–10 minutes)',
    retakeToggleLabel: 'Show retake on Simple HTML',
    retakeToggleHint: 'Guests can retake individual photo slots before printing',
    retakeEnableSuccess: 'Retake buttons enabled on Simple HTML',
    retakeDisableSuccess: 'Retake buttons hidden on Simple HTML',
    idleTimeoutSaveSuccess: 'Idle timeout updated',
    idleTimeoutUnit: 'min',
    captureCountdownLabel: 'Capture countdown',
    captureCountdownHint: 'Seconds before each shot (1–30). +/− updates the machine immediately — same as Control Page, not saved to the server.',
    captureCountdownUnit: 'sec',
    captureCountdownSaveSuccess: 'Capture countdown sent to machine',
    captureCountdownOffline: 'Machine is offline — connect the app to change countdown',
    lastUpdated: 'Last updated: {date}',
    loadError: 'Could not load Photobooth Simple mode',
    enableSuccess: 'Simple mode enabled for this device',
    disableSuccess: 'Simple mode disabled for this device',
    saveError: 'Failed to update Simple mode',
    missingMachine: 'Missing machine code',
    accessCodeTitle: 'Access code (3 characters)',
    accessCodeHint: 'Guests open the QR link, then enter this code. The code rotates every 3 minutes while idle.',
    accessCodeUpdated: 'Code updated: {date}',
    sessionInUse: 'Someone is currently using this photobooth session.',
    qrTitle: 'Capture QR code',
    qrHint: 'Scan to open the photobooth page for this machine (access code still required).',
    copyLink: 'Copy link',
    openLink: 'Open link',
  },
  mPhotoLite: {
    title: 'M-Photo Lite',
    subtitle: 'Gallery server, custom frames & PNG icons for the Android app',
    tabs: { gallery: 'Photo', customFrames: 'Custom Frame', customFramesShort: 'Frame', themes: 'Themes', themesShort: 'Theme', icons: 'Icons', stats: 'Stats' },
    galleryEmpty: 'No galleries from M-Photo Lite yet.',
    iconsDisabled: 'Device Management is not enabled — Icons cannot be managed.',
  },
  mPhotoMono: {
    title: 'M-Photo Mono',
    tabs: { subPhotos: 'Secondary photos', frames: 'Add frames', photos: 'Photo', stats: 'Stats' },
    dropActive: 'Drop photos here',
    dropIdle: 'Drag and drop photos, or click to select',
    photosHint: 'Galleries synced from the Mono app to the server.',
    totalFiltered: 'Total {n} galleries matching filters',
    total: 'Total {n} galleries',
    photoCount: '{n} photos · {p} prints',
    endOfList: 'Showing all {shown}/{total} galleries',
    emptyFiltered: 'No galleries match the filters',
    empty: 'No galleries from M-Photo Mono yet',
  },
  photos: {
    viewTabs: { groups: 'Groups', list: 'List', collections: 'Collections' },
    selectAll: 'Select all',
    downloadSelected: 'Download ({n} groups)',
    downloading: 'Downloading...',
    addToCollection: 'Add to Collection',
    dropActive: 'Drop the photos here',
    dropIdle: 'Drag and drop photos here, or click to select',
    maxFiles: 'Maximum 10 photos at once',
    uploadCta: 'Add photos',
    filterByDate: 'Date filter',
    filterByDevice: 'Device',
    allDevices: 'All devices',
    clearFilter: 'Clear',
  },
  customFrames: {
    titlePro: 'Custom Frame — M-Photo Pro',
    titleLite: 'Custom Frame — M-Photo Lite',
    titleMono: 'Custom Frame — M-Photo Mono',
    hintPro: 'Frames the admin has enabled for the M-Photo Pro app.',
    hintLite: 'Frames the admin has enabled for M-Photo Lite.',
    emptyGranted: 'Admin has not granted any custom frames yet.',
    emptyEnabled: 'Admin has not enabled any custom frames yet.',
    filterSize: 'Filter by size',
    viewUserFrames: 'View user frames',
    toggleOn: 'On — tap to turn off',
    toggleOff: 'Off — tap to turn on',
  },
  livePhotos: {
    title: 'Live Photos',
    loginRequired: 'Sign in to select a collection and view live photos.',
    emptyCollections: 'You have no collections yet.',
    selectCollection: 'Select a collection on the left to start live view.',
    emptyGallery: 'This collection has no galleries yet.',
    galleryLabel: 'Gallery:',
    uploadedAt: 'Uploaded at: {datetime}',
    collectionListTitle: 'Collection list',
    galleryListTitle: 'Gallery list',
  },
  videos: {
    title: 'My Videos',
    dropActive: 'Drop the video here',
    dropIdle: 'Drag and drop a video here, or click to select',
    maxOne: 'Maximum 1 video at once',
    created: 'Created: {date}',
  },
  sePay: {
    title: 'SePay Payment',
    subtitle: 'Configure payment gateway and print pricing',
    tabs: { config: 'SePay config', price: '4×6 print price', device: 'Devices' },
    webhookTitle: 'Webhook URL',
    webhookHint: 'Paste into SePay Dashboard → Webhooks → Create webhook',
    receivingAccount: 'Receiving account',
    linked: 'Linked — tap to change',
    noAccount: 'No account selected',
    tapToConfig: 'Tap to configure',
    saveKeysHeading: 'Save SePay gateway keys',
    apiTokenLabel: 'API Token',
    priceLabel: 'Price per 4×6 print (VND)',
    savePrice: 'Save price',
    clearInput: 'Clear input',
    deviceHeading: 'Device Management per machine',
    deviceHint: 'Enable "Require SePay QR" so the machine must scan QR before printing.',
    liteRequireQr: 'M-Photo Lite — require SePay QR',
    proRequireQr: 'M-Photo Pro — require SePay QR',
    createQrTitle: 'Create payment QR (VietQR)',
    amount: 'Amount (VND)',
    description: 'Description',
    bank: 'Bank',
    va: 'Virtual account (VA) *',
    passwordDialog: 'Confirm password',
    qrDialog: 'Scan QR to transfer',
  },
  events: {
    title: 'Event Management',
    createNew: 'Create new event',
    empty: 'You have no events yet. Create your first event!',
    code: 'Code: {code}',
    dialogCreate: 'Create new event',
    dialogUpdate: 'Update event',
    nameLabel: 'Event name',
    namePlaceholder: 'e.g. Tet Event 2025',
    submitCreate: 'Create',
    submitUpdate: 'Update',
    confirmDelete: 'Are you sure you want to delete event "{name}"?',
  },
  profile: {
    title: 'Personal information',
    loading: 'Loading user information...',
    changeBackground: 'Change background',
    changeAvatar: 'Change avatar',
    basicInfo: 'Basic information',
    username: 'Username',
    email: 'Email',
    passwordSection: 'Change password (optional)',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    submit: 'Update profile',
    submitting: 'Updating...',
  },
  themes: {
    title: 'Theme Management',
    createNew: 'Create new theme',
    customFrameList: 'Custom frame list',
    proShowAllTitle: 'Show all custom frames (M-Photo Pro)',
    proShowAllHint: 'On: Pro machines show every layout. Off: only layouts in the active theme.',
    emptyTitle: 'No themes yet',
    emptyHint: 'Create your first theme to organize frames for M-Photo Pro.',
    emptyHintLite: 'Create themes for M-Photo Lite here — separate from Pro themes.',
    active: 'Active',
    inactive: 'Inactive',
    activeMliteLabel: 'Capture',
    mobileUploadProTitle: 'Mobile upload',
    mobileUploadProHint: 'Separate from Lite — only when Pro opens HTML mobile upload.',
    mobileUploadLiteTitle: 'Mobile upload (Lite)',
    mobileUploadLiteHint: 'Separate from Pro — only when M-Photo Lite opens HTML mobile upload.',
    mobileUploadOtherStatus: 'Other channel: {status}',
    scheduleOpen: 'Setting',
    scheduleTitle: 'Setting',
    scheduleHint: 'When on, this theme only applies between the start and end time.',
    scheduleEnable: 'Only during a time range',
    scheduleFrom: 'From',
    scheduleUntil: 'Until',
    machineFilterEnable: 'Pro machines',
    machineFilterEnableLite: 'Android machines',
    machineFilterSelectAll: 'Select all',
    machineFilterClearAll: 'Clear all',
    machineFilterHint: 'Only ticked Pro machines get this theme. If none are ticked, it is not applied to any machine.',
    machineFilterHintLite: 'Only ticked Android machines (M-Photo Lite) get this theme. If none are ticked, it is not applied to any machine.',
    machineFilterNeedFrame: 'Please add a frame before filtering machines.',
    machineFilterEmpty: 'This account has no Pro machines yet.',
    machineFilterEmptyLite: 'This account has no Android machines yet.',
    machineFilterLoading: 'Loading machines...',
    machineFilterButton: 'Filter machines',
    machineFilterSaved: 'Machine filter saved',
    machineFilterSaveFail: 'Could not save the machine filter',
    scheduleAlways: 'Any time',
    scheduleAllMachines: 'All machines',
    scheduleNoMachines: 'No machines',
    scheduleMachineCount: '{n} machines',
    scheduleOutside: 'Outside the time range',
    dialogCreate: 'Create new theme',
    dialogEdit: 'Update theme',
    name: 'Theme name',
    description: 'Description',
    tags: 'Tags (comma-separated)',
    imageOptional: 'Theme image (optional)',
    dropImage: 'Click to choose an image or drag and drop here',
    imageFormats: 'PNG, JPG, JPEG (max 10MB)',
    breadcrumb: 'Themes',
    noDescription: 'No description',
    metaCounts: '{n} Custom Frames • {m} User Frames',
    addCustomFrame: 'Add Custom Frame',
    framesInTheme: 'Custom Frames in theme',
    emptyFramesTitle: 'No Custom Frames yet',
    emptyFramesHint: 'Tap "Add Custom Frame" to add frames to this theme',
    addDialogTitle: 'Add Custom Frame to theme',
    addDialogHint: 'Only custom frames enabled for M-Photo Pro are shown.',
    addDialogHintLite: 'Only custom frames enabled for M-Photo Lite are shown.',
    noLiteFrames: 'No custom frames enabled for Lite yet.',
    pickUserFramesTitle: 'Choose user frames',
    pickUserFramesHint: 'Select user frames of this custom frame to add to the theme.',
    pickUserFramesUpload: 'Upload user frames',
    pickUserFramesUploadHint: 'PNG, JPG. Up to 10 files, 5MB each.',
    pickUserFramesUploading: 'Uploading user frames...',
    pickUserFramesEmpty: 'This custom frame has no user frames yet.',
    pickUserFramesAdd: 'Add {n} user frames',
    pickUserFramesAddFrame: 'Add frame only',
    searchPlaceholder: 'Search by name or size...',
    filterByRatio: 'Filter by aspect ratio',
    noProFrames: 'No custom frames enabled for Pro yet.',
    allAddedOrFiltered: 'All frames are already in the theme or do not match filters',
    notFound: 'Theme not found',
  },
  customerInfo: {
    title: 'Customer Information',
    subtitle: 'Manage customer info and collection settings',
    settingTitle: 'Information collection settings',
    enabled: 'On — customers must enter info when viewing galleries',
    disabled: 'Off — customers do not need to enter info when viewing galleries',
    listTitle: 'Customer list ({total})',
    export: 'Export customer info',
    empty: 'No customer information yet',
    endMessage: 'Showing all {total} customers',
    colImage: 'Photo',
    colEmail: 'Email',
    colName: 'Name',
    colActions: 'Actions',
    noImage: 'No photo',
    editDialog: 'Edit customer information',
    confirmDelete: 'Are you sure you want to delete this customer information?',
  },
  software: {
    title: 'Software',
    latestVersion: 'Latest version ({channel})',
    fileName: 'File name:',
    fileSize: 'Size:',
    uploadDate: 'Upload date:',
    download: 'Download',
    noUpdate: 'No new version available to download',
    updateInfo: 'Update information',
  },
  aiCreate: {
    title: 'Create AI image',
    subtitle: 'Create an AI theme first, then add backgrounds inside that theme.',
    disabled: 'This account is not enabled for AI images.',
    createTheme: 'Create AI theme',
    viewUsage: 'Generation history',
    usageTheme: 'Theme',
    usageBackground: 'Background',
    editTheme: 'Edit AI theme',
    themeName: 'Theme name',
    description: 'Description',
    themeImage: 'Theme image',
    noThemes: 'No AI themes yet. Create a theme before adding backgrounds.',
    backgrounds: 'AI backgrounds',
    backgroundCount: '{n} AI background',
    emptyBackgrounds: 'This theme has no AI backgrounds yet.',
    createBackground: 'Create AI background',
    editBackground: 'Edit AI background',
    backgroundName: 'Background name',
    prompt: 'Prompt',
    tags: 'Tags',
    tagMale: 'Male',
    tagFemale: 'Female',
    tagGroup: 'Group',
    tagsRequired: 'Choose at least one tag.',
    image: 'Image',
    referenceImage: 'Reference image (optional)',
    referenceHint: 'The customer photo is image 1. This reference is image 2.',
    removeReference: 'Remove reference',
    proEnable: 'Pro machines',
    proHint: 'Pro app and mobile upload opened from a Pro machine.',
    liteEnable: 'Lite machines',
    liteHint: 'Android app and mobile upload opened from a Lite machine.',
    machineHint: 'Only ticked machines see this theme. If none are ticked, it is hidden.',
    noMachines: 'No machines of this type yet.',
    back: 'Back',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    confirmDeleteTheme: 'Delete this AI theme and every background inside it?',
    confirmDeleteBackground: 'Delete this AI background?',
  },
  deviceMgmt: {
    title: 'Device Management',
    subtitle: 'Select a machine to view the random code and upload photos from your phone',
    emptyTitle: 'No machines yet',
    emptyHint: 'Register a machine before using Device Management',
    machineCode: 'Machine code:',
    running: 'Running',
    paused: 'Paused',
    platformWindows: 'Windows',
    platformAndroid: 'Android',
    productLite: 'Lite',
    productMono: 'Mono',
    productPro: 'Pro',
    noQrFeatures: 'This Mono device does not have Mobile Upload or Page Control QR codes.',
    viewAccess: 'Access',
    renameTitle: 'Rename machine',
    renameSuccess: 'Machine name updated',
    deleteTitle: 'Delete machine',
    deleteConfirm: 'Are you sure you want to delete machine "{code}"? This cannot be undone.',
    deleteSuccess: 'Machine deleted successfully',
    nameLabel: 'Machine name',
    namePlaceholder: 'Enter new machine name',
    back: 'Back to machine list',
    backShort: 'Back',
    tabs: {
      upload: 'Mobile Upload',
      uploadShort: 'Upload',
      control: 'Page Control',
      controlShort: 'Control',
      photos: 'Photos',
      photosShort: 'Photos',
      edit: 'Edit list',
      editShort: 'Edit',
      colorApps: 'Color Apps',
      colorAppsShort: 'Color',
      photobooth: 'Photobooth',
      photoboothShort: 'Booth',
      qrEdit: 'Edit QR',
      qrEditShort: 'QR',
    },
    qrEditor: {
      title: 'Print QR position',
      hint: 'Adjust offset and QR size per layout or frame on this machine. The newer edit time wins when syncing with mlite.',
      frame: 'Frame',
      layoutDefault: 'Layout default',
      userFrames: 'User frames',
      offsetX: 'Offset X',
      offsetY: 'Offset Y',
      size: 'QR size',
      step: 'Step',
      showQr: 'Show QR on prints',
      lastEdited: 'Last edited: {date}',
      saveSuccess: 'QR position saved',
      saveError: 'Could not save QR position',
      loadError: 'Could not load QR position',
      reset: 'Reset',
    },
    photosFilteredBy: 'Filtered by machine {code}',
    photosEmptyTitle: 'No photos for this machine',
    photosEmptyHint: 'No galleries match machine code {code}',
    photosEnd: 'All galleries for machine {code} loaded',
    photosLoadError: 'Could not load photos',
    photosNoLink: 'Gallery link is not available',
    photosDeleteTitle: 'Delete photo group',
    photosDeleteConfirm: 'Are you sure you want to delete this photo group? This cannot be undone.',
    photosDeleteSuccess: 'Photo group deleted',
    photosDeleteError: 'Could not delete photo group',
    machineCodeLabel: 'Machine code',
    randomCodeTitle: 'Random code (3 characters)',
    randomCodeHint: 'This code auto-refreshes every 3 minutes from the M-Photo Lite app',
    lastUpdated: 'Last updated: {date}',
    qrUploadTitle: 'QR code to scan and upload photos',
    qrUploadHint: 'Scan this QR with your phone to open the photo upload page',
    fullCode: 'Full code:',
    copyLink: 'Copy link',
    openNewTab: 'Open in new tab',
    controlQrTitle: 'Machine control QR code',
    controlQrHint: 'Scan this QR with your phone to open the machine control page',
    editQrTitle: 'Gallery edit / sign QR',
    editQrHint: 'Scan to open the edit list for galleries waiting to be signed on this machine',
    link: 'Link:',
    notFound: 'Machine information not found',
    limitTitle: 'Device access limits',
    limitHint: 'Set daily access and max print copies per device. Enter 0 for unlimited access.',
    accessLabel: 'Accesses',
    accessHint: '0 = unlimited · resets daily',
    printCopiesLabel: 'Max print copies',
    printCopiesHint: 'Default 1 · max 10 (4×6)',
    uiEnabledTitle: 'Show Mobile Upload on machine',
    uiEnabledHint: 'Show or hide the Mobile Upload button / QR on this machine app (Lite & Pro).',
    uiEnabledOn: 'Visible on machine',
    uiEnabledOff: 'Hidden on machine',
    uiEnabledSaveSuccess: 'Mobile Upload visibility updated',
    uiEnabledSaveError: 'Could not update Mobile Upload visibility',
    uiEnabledLoadError: 'Could not load Mobile Upload visibility',
    controlUiTitle: 'Show Control for this user',
    controlUiHint: 'When off, hide the Control tab on the user account and the Control Page item in mlite Settings.',
    controlUiSaveSuccess: 'Control visibility updated',
    controlUiSaveError: 'Could not update Control visibility',
    controlUiLoadError: 'Could not load Control visibility',
    bgRemovalTitle: 'Background removal (this machine)',
    bgRemovalHint: 'When on: show the AI background removal toggle on this Pro machine (starts OFF) and the Backgrounds tab in frame detail. When off: hide both.',
    bgRemovalSaveSuccess: 'Background removal updated for this machine',
    bgRemovalSaveError: 'Could not update background removal',
    bgRemovalLoadError: 'Could not load background removal status',
    limitLoadError: 'Could not load Mobile Upload limits.',
    limitSaveSuccess: 'Mobile Upload limits saved.',
    limitSaveError: 'Could not save limits.',
    accessInvalid: 'Please enter an integer from 0 to 9999.',
    printCopiesInvalid: 'Max print copies must be from 1 to 10.',
    restartApp: 'Reset',
    shutdownApp: 'Quit app',
    restartConfirmTitle: 'Restart the app?',
    restartConfirmBody: 'The machine app will restart (same as after unplugging the camera). Continue?',
    shutdownConfirmTitle: 'Quit the app?',
    shutdownConfirmBody: 'The machine app will close completely. Continue?',
    restartSent: 'Restart command sent to the machine',
    shutdownSent: 'Quit command sent to the machine',
    appOfflineCantRemote: 'Machine is offline — open the app first',
    confirmAction: 'Confirm',
  },
  icons: {
    dropActive: 'Drop PNG icon files here',
    dropIdle: 'Drag and drop PNG icons here, or click to select',
    hint: 'PNG only, max 30 files at once. Files over 500KB are compressed on upload.',
  },
};

const vi: PagesMessages = {
  common: {
    cancel: 'Hủy',
    save: 'Lưu',
    view: 'Xem',
    loading: 'Đang tải...',
    delete: 'Xóa',
    edit: 'Sửa',
    refresh: 'Làm mới',
    close: 'Đóng',
    all: 'Tất cả',
    newest: 'Mới nhất',
    oldest: 'Cũ nhất',
    newestShort: 'Mới',
    oldestShort: 'Cũ',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    sortBy: 'Sắp xếp theo',
    updating: 'Đang cập nhật...',
    saving: 'Đang lưu...',
    update: 'Cập nhật',
    create: 'Tạo',
    add: 'Thêm',
    copy: 'Copy',
    purgedOldGalleries: 'Đã xóa {n} gallery cũ hơn 1 năm',
  },
  mPhotoPro: {
    title: 'M-Photo Pro',
    subtitle: 'Gallery & custom frame cho app desktop Pro',
    noAccess: 'Tài khoản chưa được cấp quyền xem M-Photo Pro.',
    tabs: { photos: 'Ảnh', customFrames: 'Custom Frame', customFramesShort: 'Khung', themes: 'Themes', themesShort: 'Theme', collections: 'Bộ sưu tập', icons: 'Biểu tượng', stats: 'Thống kê' },
  },
  colorApps: {
    title: 'Màu app',
    titleAll: 'Màu app — tất cả thiết bị',
    titleMachine: 'Màu app — thiết bị này',
    description:
      'Chọn màu chủ đạo — app sẽ dùng bộ màu nhạt (nền, viền, soft…) giống màn hình chọn màu trên máy.',
    descriptionAll:
      'Đổi màu giao diện app cho mọi thiết bị trong tài khoản. Vẫn có thể đặt màu riêng từng máy ở tab Màu app của máy đó.',
    descriptionMachine:
      'Đổi màu giao diện app chỉ cho thiết bị này. Các máy khác trong tài khoản giữ màu riêng.',
    hexLabel: 'Mã màu (hex)',
    pickColor: 'Chọn màu',
    hexHelper: 'Ví dụ: #d45d7f — Enter hoặc bấm Áp dụng để lưu',
    apply: 'Áp dụng',
    presets: 'Màu đề xuất',
    derivedPalette: 'Bộ màu dùng trên app (Derived palette)',
    preview: 'Xem trước giao diện',
    primaryBtn: 'Nút chính',
    secondaryBtn: 'Nút phụ',
    badgeChip: 'Badge / chip',
    loadError: 'Không tải được màu giao diện',
    saveSuccess: 'Đã lưu màu giao diện app',
    saveSuccessAll: 'Đã lưu màu cho tất cả thiết bị',
    saveSuccessMachine: 'Đã lưu màu cho thiết bị này',
    saveError: 'Lưu màu thất bại',
    invalidHex: 'Mã màu không hợp lệ (#RRGGBB)',
    slots: {
      bg: 'Nền',
      surface: 'Bề mặt',
      border: 'Viền',
      soft: 'Nhạt',
      primary: 'Chính',
      hover: 'Hover',
      text: 'Chữ',
    },
  },
  photoboothSimple: {
    title: 'Photobooth',
    titleMachine: 'Photobooth',
    descriptionMachine: 'Bật để máy hiện QR chụp từ điện thoại.',
    toggleLabel: 'Chế độ đơn giản',
    toggleOnHint: 'Đang bật',
    toggleOffHint: 'Đang tắt',
    maxAccessLabel: 'Lượt in / ngày',
    maxAccessHint: '0 = không giới hạn',
    maxAccessSaveSuccess: 'Đã cập nhật giới hạn lượt theo thiết bị',
    captureIdleLabel: 'Thời gian chờ trang chụp',
    captureIdleHint: 'Hết giờ không thao tác trên màn chụp sẽ về trang chủ (1–10 phút)',
    previewIdleLabel: 'Thời gian chờ trang xem trước',
    previewIdleHint: 'Hết giờ không thao tác trên màn xem trước sẽ tự in / về trang chủ (1–10 phút)',
    retakeToggleLabel: 'Hiện nút chụp lại trên Simple HTML',
    retakeToggleHint: 'Khách có thể chụp lại từng ô ảnh trước khi in',
    retakeEnableSuccess: 'Đã hiện nút chụp lại trên Simple HTML',
    retakeDisableSuccess: 'Đã ẩn nút chụp lại trên Simple HTML',
    idleTimeoutSaveSuccess: 'Đã cập nhật thời gian đếm ngược',
    idleTimeoutUnit: 'phút',
    captureCountdownLabel: 'Đếm ngược khi chụp',
    captureCountdownHint: 'Số giây đếm trước mỗi lần chụp (1–30). Bấm +/− là máy đổi ngay — giống Control Page, không lưu server.',
    captureCountdownUnit: 'giây',
    captureCountdownSaveSuccess: 'Đã gửi đếm ngược xuống máy',
    captureCountdownOffline: 'Máy đang offline — hãy mở app để đổi đếm ngược',
    lastUpdated: 'Cập nhật lần cuối: {date}',
    loadError: 'Không tải được chế độ Photobooth Simple',
    enableSuccess: 'Đã bật chế độ đơn giản cho thiết bị này',
    disableSuccess: 'Đã tắt chế độ đơn giản cho thiết bị này',
    saveError: 'Cập nhật chế độ đơn giản thất bại',
    missingMachine: 'Thiếu mã máy',
    accessCodeTitle: 'Mã truy cập (3 ký tự)',
    accessCodeHint: 'Khách quét QR rồi nhập mã này. Mã đổi mỗi 3 phút khi máy đang rảnh.',
    accessCodeUpdated: 'Mã cập nhật: {date}',
    sessionInUse: 'Đang có người sử dụng phiên photobooth này.',
    qrTitle: 'QR Code truy cập chụp',
    qrHint: 'Quét để mở trang photobooth của máy (vẫn cần nhập mã truy cập).',
    copyLink: 'Copy link',
    openLink: 'Mở link',
  },
  mPhotoLite: {
    title: 'M-Photo Lite',
    subtitle: 'Gallery server, custom frame & icon PNG cho app Android',
    tabs: { gallery: 'Ảnh', customFrames: 'Custom Frame', customFramesShort: 'Khung', themes: 'Themes', themesShort: 'Theme', icons: 'Biểu tượng', stats: 'Thống kê' },
    galleryEmpty: 'Chưa có gallery nào từ M-Photo Lite.',
    iconsDisabled: 'Tài khoản chưa được bật Device Management — không thể quản lý Icons.',
  },
  mPhotoMono: {
    title: 'M-Photo Mono',
    tabs: { subPhotos: 'Thêm ảnh phụ', frames: 'Thêm khung', photos: 'Ảnh', stats: 'Thống kê' },
    dropActive: 'Thả ảnh vào đây',
    dropIdle: 'Kéo thả ảnh hoặc click để chọn',
    photosHint: 'Danh sách gallery ảnh đã đồng bộ từ app Mono lên server.',
    totalFiltered: 'Tổng cộng {n} gallery phù hợp với bộ lọc',
    total: 'Tổng cộng {n} gallery',
    photoCount: '{n} ảnh · {p} lượt in',
    endOfList: 'Đã hiển thị hết {shown}/{total} gallery',
    emptyFiltered: 'Không tìm thấy gallery nào phù hợp với bộ lọc',
    empty: 'Chưa có gallery nào từ M-Photo Mono',
  },
  photos: {
    viewTabs: { groups: 'Nhóm', list: 'Danh sách', collections: 'Bộ sưu tập' },
    selectAll: 'Chọn tất cả',
    downloadSelected: 'Tải về ({n} nhóm)',
    downloading: 'Đang tải...',
    addToCollection: 'Thêm vào Collection',
    dropActive: 'Thả ảnh vào đây',
    dropIdle: 'Kéo thả ảnh vào đây, hoặc click để chọn',
    maxFiles: 'Tối đa 10 ảnh mỗi lần',
    uploadCta: 'Thêm ảnh',
    filterByDate: 'Lọc ngày',
    filterByDevice: 'Thiết bị',
    allDevices: 'Tất cả thiết bị',
    clearFilter: 'Xóa lọc',
  },
  customFrames: {
    titlePro: 'Custom Frame — M-Photo Pro',
    titleLite: 'Custom Frame — M-Photo Lite',
    titleMono: 'Custom Frame — M-Photo Mono',
    hintPro: 'Các khung admin đã bật cho app M-Photo Pro.',
    hintLite: 'Các khung admin đã bật cho M-Photo Lite.',
    emptyGranted: 'Admin chưa cấp custom frame nào.',
    emptyEnabled: 'Admin chưa bật custom frame nào.',
    filterSize: 'Lọc kích thước',
    viewUserFrames: 'Xem user frames',
    toggleOn: 'Đang bật — tắt',
    toggleOff: 'Đang tắt — bật',
  },
  livePhotos: {
    title: 'Live Photos',
    loginRequired: 'Đăng nhập để chọn collection và xem live view.',
    emptyCollections: 'Bạn chưa có collection nào.',
    selectCollection: 'Chọn collection bên trái để bắt đầu live view.',
    emptyGallery: 'Collection này chưa có gallery nào.',
    galleryLabel: 'Gallery:',
    uploadedAt: 'Uploaded at: {datetime}',
    collectionListTitle: 'Danh sách collection',
    galleryListTitle: 'Danh sách gallery',
  },
  videos: {
    title: 'Videos của tôi',
    dropActive: 'Thả video vào đây',
    dropIdle: 'Kéo thả video vào đây, hoặc click để chọn',
    maxOne: 'Tối đa 1 video mỗi lần',
    created: 'Tạo lúc: {date}',
  },
  sePay: {
    title: 'Thanh toán SePay',
    subtitle: 'Cấu hình cổng thanh toán và giá in ảnh',
    tabs: { config: 'Cấu hình SePay', price: 'Giá in 4×6', device: 'Thiết bị' },
    webhookTitle: 'Webhook URL',
    webhookHint: 'Dán vào SePay Dashboard → Webhooks → Tạo webhook mới',
    receivingAccount: 'Tài khoản nhận tiền',
    linked: 'Đã liên kết — bấm để đổi',
    noAccount: 'Chưa chọn tài khoản',
    tapToConfig: 'Bấm để cấu hình',
    saveKeysHeading: 'Lưu mã cổng SePay',
    apiTokenLabel: 'API Token',
    priceLabel: 'Giá 1 tấm 4×6 (VND)',
    savePrice: 'Lưu giá',
    clearInput: 'Xóa ô nhập',
    deviceHeading: 'Device Management theo máy',
    deviceHint: 'Bật "Bắt buộc QR SePay" để máy phải quét QR trước khi in.',
    liteRequireQr: 'M-Photo Lite — bắt buộc QR SePay',
    proRequireQr: 'M-Photo Pro — bắt buộc QR SePay',
    createQrTitle: 'Tạo QR thanh toán (VietQR)',
    amount: 'Số tiền (VND)',
    description: 'Mô tả',
    bank: 'Ngân hàng',
    va: 'Tài khoản ảo (VA) *',
    passwordDialog: 'Xác nhận mật khẩu',
    qrDialog: 'Quét QR để chuyển khoản',
  },
  events: {
    title: 'Quản lý Sự kiện',
    createNew: 'Tạo sự kiện mới',
    empty: 'Bạn chưa có sự kiện nào. Hãy tạo sự kiện đầu tiên!',
    code: 'Mã: {code}',
    dialogCreate: 'Tạo sự kiện mới',
    dialogUpdate: 'Cập nhật sự kiện',
    nameLabel: 'Tên sự kiện',
    namePlaceholder: 'Ví dụ: Sự kiện Tết 2025',
    submitCreate: 'Tạo',
    submitUpdate: 'Cập nhật',
    confirmDelete: 'Bạn có chắc chắn muốn xóa sự kiện "{name}"?',
  },
  profile: {
    title: 'Thông tin cá nhân',
    loading: 'Đang tải thông tin người dùng...',
    changeBackground: 'Đổi hình nền',
    changeAvatar: 'Đổi ảnh đại diện',
    basicInfo: 'Thông tin cơ bản',
    username: 'Tên người dùng',
    email: 'Email',
    passwordSection: 'Đổi mật khẩu (không bắt buộc)',
    currentPassword: 'Mật khẩu hiện tại',
    newPassword: 'Mật khẩu mới',
    confirmPassword: 'Xác nhận mật khẩu mới',
    submit: 'Cập nhật thông tin',
    submitting: 'Đang cập nhật...',
  },
  themes: {
    title: 'Quản lý Themes',
    createNew: 'Tạo Theme Mới',
    customFrameList: 'Danh sách custom frame',
    proShowAllTitle: 'Bật toàn bộ custom frame (M-Photo Pro)',
    proShowAllHint: 'Bật: máy Pro hiện mọi layout. Tắt: chỉ hiện layout thuộc theme đang bật.',
    emptyTitle: 'Chưa có theme nào',
    emptyHint: 'Tạo theme đầu tiên cho M-Photo Pro.',
    emptyHintLite: 'Tạo theme riêng cho M-Photo Lite — không dùng chung với Pro.',
    active: 'Đang bật',
    inactive: 'Đang tắt',
    activeMliteLabel: 'Chụp ảnh',
    mobileUploadProTitle: 'Tải ảnh',
    mobileUploadProHint: 'Riêng với Lite — chỉ khi máy Pro gọi HTML mobile upload.',
    mobileUploadLiteTitle: 'Mobile upload (Lite)',
    mobileUploadLiteHint: 'Riêng với Pro — chỉ khi M-Photo Lite gọi HTML mobile upload.',
    mobileUploadOtherStatus: 'Kênh còn lại: {status}',
    scheduleOpen: 'Cài đặt',
    scheduleTitle: 'Cài đặt',
    scheduleHint: 'Khi bật, theme chỉ áp dụng trong khoảng thời gian đã chọn.',
    scheduleEnable: 'Cài đặt thời gian',
    scheduleFrom: 'Từ',
    scheduleUntil: 'Đến',
    machineFilterEnable: 'Máy Pro',
    machineFilterEnableLite: 'Máy Android',
    machineFilterSelectAll: 'Chọn tất cả',
    machineFilterClearAll: 'Bỏ chọn tất cả',
    machineFilterHint: 'Chỉ máy Pro được tích mới được áp dụng. Không tích máy nào thì không áp dụng cho máy nào.',
    machineFilterHintLite: 'Chỉ máy Android (M-Photo Lite) được tích mới được áp dụng. Không tích máy nào thì không áp dụng cho máy nào.',
    machineFilterNeedFrame: 'Vui lòng thêm frame để lọc máy.',
    machineFilterEmpty: 'Tài khoản này chưa có máy Pro nào.',
    machineFilterEmptyLite: 'Tài khoản này chưa có máy Android nào.',
    machineFilterLoading: 'Đang tải danh sách máy...',
    machineFilterButton: 'Lọc máy',
    machineFilterSaved: 'Đã lưu lọc máy',
    machineFilterSaveFail: 'Không lưu được lọc máy',
    scheduleAlways: 'Mọi lúc',
    scheduleAllMachines: 'Mọi máy',
    scheduleNoMachines: 'Không áp máy',
    scheduleMachineCount: '{n} máy',
    scheduleOutside: 'Đang ngoài giờ',
    dialogCreate: 'Tạo Theme Mới',
    dialogEdit: 'Cập nhật Theme',
    name: 'Tên Theme',
    description: 'Mô tả',
    tags: 'Tags (phân cách bằng dấu phẩy)',
    imageOptional: 'Ảnh Theme (Tùy chọn)',
    dropImage: 'Click để chọn ảnh hoặc kéo thả vào đây',
    imageFormats: 'PNG, JPG, JPEG (Tối đa 10MB)',
    breadcrumb: 'Themes',
    noDescription: 'Không có mô tả',
    metaCounts: '{n} Custom Frames • {m} User Frames',
    addCustomFrame: 'Thêm Custom Frame',
    framesInTheme: 'Custom Frames trong Theme',
    emptyFramesTitle: 'Chưa có Custom Frame nào',
    emptyFramesHint: 'Bấm "Thêm Custom Frame" để chọn từng khung đưa vào theme',
    addDialogTitle: 'Thêm Custom Frame vào theme',
    addDialogHint: 'Chỉ hiển thị custom frame đã bật cho M-Photo Pro.',
    addDialogHintLite: 'Chỉ hiển thị custom frame đã bật cho M-Photo Lite.',
    noLiteFrames: 'Chưa có custom frame nào được bật cho Lite.',
    pickUserFramesTitle: 'Chọn user frame',
    pickUserFramesHint: 'Chọn user frame của khung này để đưa vào theme.',
    pickUserFramesUpload: 'Upload user frame',
    pickUserFramesUploadHint: 'PNG, JPG. Tối đa 10 file, mỗi file 5MB.',
    pickUserFramesUploading: 'Đang upload user frame...',
    pickUserFramesEmpty: 'Khung này chưa có user frame.',
    pickUserFramesAdd: 'Thêm {n} user frame',
    pickUserFramesAddFrame: 'Chỉ thêm khung',
    searchPlaceholder: 'Tìm theo tên hoặc size...',
    filterByRatio: 'Lọc theo tỉ lệ khung',
    noProFrames: 'Chưa có custom frame nào được bật cho Pro.',
    allAddedOrFiltered: 'Tất cả custom frame đã có trong theme hoặc không khớp bộ lọc',
    notFound: 'Theme không tồn tại',
  },
  customerInfo: {
    title: 'Thông tin khách hàng',
    subtitle: 'Quản lý thông tin khách hàng và cài đặt thu thập thông tin',
    settingTitle: 'Cài đặt thu thập thông tin',
    enabled: 'Đang bật - Khách hàng sẽ được yêu cầu nhập thông tin khi xem gallery',
    disabled: 'Đang tắt - Khách hàng không cần nhập thông tin khi xem gallery',
    listTitle: 'Danh sách khách hàng ({total})',
    export: 'Tải thông tin customer',
    empty: 'Chưa có thông tin khách hàng nào',
    endMessage: 'Đã hiển thị tất cả {total} khách hàng',
    colImage: 'Ảnh',
    colEmail: 'Email',
    colName: 'Tên',
    colActions: 'Thao tác',
    noImage: 'Không có ảnh',
    editDialog: 'Chỉnh sửa thông tin khách hàng',
    confirmDelete: 'Bạn có chắc chắn muốn xóa thông tin khách hàng này?',
  },
  software: {
    title: 'Phần mềm',
    latestVersion: 'Phiên bản mới nhất ({channel})',
    fileName: 'Tên file:',
    fileSize: 'Kích thước:',
    uploadDate: 'Ngày upload:',
    download: 'Tải xuống',
    noUpdate: 'Hiện tại chưa có phiên bản mới để tải về',
    updateInfo: 'Thông tin cập nhật',
  },
  aiCreate: {
    title: 'Tạo hình AI',
    subtitle: 'Tạo chủ đề AI trước, rồi thêm các nền AI bên trong chủ đề đó.',
    disabled: 'Tài khoản này chưa được bật tạo hình AI.',
    createTheme: 'Tạo chủ đề AI',
    viewUsage: 'Lịch sử tạo ảnh',
    usageTheme: 'Chủ đề',
    usageBackground: 'Nền',
    editTheme: 'Sửa chủ đề AI',
    themeName: 'Tên chủ đề',
    description: 'Mô tả',
    themeImage: 'Hình chủ đề',
    noThemes: 'Chưa có chủ đề AI. Hãy tạo chủ đề trước khi thêm nền.',
    backgrounds: 'Nền AI',
    backgroundCount: '{n} nền AI',
    emptyBackgrounds: 'Chủ đề này chưa có nền AI.',
    createBackground: 'Tạo nền AI',
    editBackground: 'Sửa nền AI',
    backgroundName: 'Tên nền',
    prompt: 'Prompt',
    tags: 'Tag',
    tagMale: 'Nam',
    tagFemale: 'Nữ',
    tagGroup: 'Nhóm',
    tagsRequired: 'Chọn ít nhất một tag.',
    image: 'Hình ảnh',
    referenceImage: 'Ảnh tham khảo (tuỳ chọn)',
    referenceHint: 'Ảnh khách chụp là ảnh 1. Ảnh này là ảnh 2 để AI tham khảo.',
    removeReference: 'Bỏ ảnh tham khảo',
    proEnable: 'Máy Pro',
    proHint: 'App Pro và mobile upload mở từ máy Pro.',
    liteEnable: 'Máy Lite',
    liteHint: 'App Android và mobile upload mở từ máy Lite.',
    machineHint: 'Chỉ máy được tích mới thấy. Không tích máy nào thì không hiện.',
    noMachines: 'Chưa có máy loại này.',
    back: 'Quay lại',
    save: 'Lưu',
    cancel: 'Hủy',
    delete: 'Xóa',
    confirmDeleteTheme: 'Xóa chủ đề AI này và toàn bộ nền bên trong?',
    confirmDeleteBackground: 'Xóa nền AI này?',
  },
  deviceMgmt: {
    title: 'Quản lý thiết bị',
    subtitle: 'Chọn máy để xem mã random code và upload ảnh từ điện thoại',
    emptyTitle: 'Chưa có máy nào',
    emptyHint: 'Bạn cần đăng ký máy trước khi sử dụng tính năng Device Management',
    machineCode: 'Mã máy:',
    running: 'Đang hoạt động',
    paused: 'Tạm dừng',
    platformWindows: 'Windows',
    platformAndroid: 'Android',
    productLite: 'Lite',
    productMono: 'Mono',
    productPro: 'Pro',
    noQrFeatures: 'Thiết bị Mono không có mã QR Mobile Upload và Page Control.',
    viewAccess: 'Truy cập',
    renameTitle: 'Đổi tên máy',
    renameSuccess: 'Đã cập nhật tên máy thành công',
    deleteTitle: 'Xóa máy',
    deleteConfirm: 'Bạn có chắc muốn xóa máy "{code}"? Thao tác này không thể hoàn tác.',
    deleteSuccess: 'Đã xóa máy thành công',
    nameLabel: 'Tên máy',
    namePlaceholder: 'Nhập tên máy mới',
    back: 'Quay lại danh sách máy',
    backShort: 'Quay lại',
    tabs: {
      upload: 'Tải ảnh',
      uploadShort: 'Tải lên',
      control: 'Điều khiển',
      controlShort: 'Điều khiển',
      photos: 'Ảnh',
      photosShort: 'Ảnh',
      edit: 'Danh sách sửa',
      editShort: 'Edit',
      colorApps: 'Màu app',
      colorAppsShort: 'Màu',
      photobooth: 'Photobooth',
      photoboothShort: 'Booth',
      qrEdit: 'Chỉnh sửa QR',
      qrEditShort: 'QR',
    },
    qrEditor: {
      title: 'Vị trí QR in',
      hint: 'Chỉnh độ lệch và kích thước QR theo từng layout hoặc khung trên máy này. Khi đồng bộ với mlite, bên nào chỉnh mới hơn sẽ được giữ.',
      frame: 'Khung',
      layoutDefault: 'Mặc định layout',
      userFrames: 'User frame',
      offsetX: 'Lệch X',
      offsetY: 'Lệch Y',
      size: 'Kích thước QR',
      step: 'Bước nhảy',
      showQr: 'Hiện QR khi in',
      lastEdited: 'Chỉnh lần cuối: {date}',
      saveSuccess: 'Đã lưu vị trí QR',
      saveError: 'Không lưu được vị trí QR',
      loadError: 'Không tải được vị trí QR',
      reset: 'Đặt lại',
    },
    photosFilteredBy: 'Đã lọc theo máy {code}',
    photosEmptyTitle: 'Chưa có ảnh của máy này',
    photosEmptyHint: 'Không có gallery nào khớp mã máy {code}',
    photosEnd: 'Đã tải hết gallery của máy {code}',
    photosLoadError: 'Không tải được ảnh',
    photosNoLink: 'Không có link gallery',
    photosDeleteTitle: 'Xóa nhóm ảnh',
    photosDeleteConfirm: 'Bạn có chắc muốn xóa nhóm ảnh này? Thao tác không thể hoàn tác.',
    photosDeleteSuccess: 'Đã xóa nhóm ảnh',
    photosDeleteError: 'Không xóa được nhóm ảnh',
    machineCodeLabel: 'Mã máy',
    randomCodeTitle: 'Mã Random Code (3 ký tự)',
    randomCodeHint: 'Mã này tự động thay đổi mỗi 3 phút từ ứng dụng M-Photo Lite',
    lastUpdated: 'Cập nhật lần cuối: {date}',
    qrUploadTitle: 'QR Code để quét và upload ảnh',
    qrUploadHint: 'Quét QR code này bằng điện thoại để mở trang upload ảnh',
    fullCode: 'Mã đầy đủ:',
    copyLink: 'Copy link',
    openNewTab: 'Mở trong tab mới',
    controlQrTitle: 'QR Code điều khiển máy',
    controlQrHint: 'Quét QR code này bằng điện thoại để mở trang điều khiển máy',
    editQrTitle: 'QR Edit / ký tên gallery',
    editQrHint: 'Quét để mở danh sách gallery chờ chỉnh sửa / ký tên trên máy',
    link: 'Link:',
    notFound: 'Không tìm thấy thông tin máy',
    limitTitle: 'Giới hạn theo thiết bị',
    limitHint: 'Giới hạn lượt truy cập và số bản in mỗi thiết bị trong ngày. Nhập 0 để không giới hạn truy cập.',
    accessLabel: 'Lượt truy cập',
    accessHint: '0 = không giới hạn · reset mỗi ngày',
    printCopiesLabel: 'Số bản in tối đa',
    printCopiesHint: 'Mặc định 1 · tối đa 10 bản 4×6',
    uiEnabledTitle: 'Hiện Mobile Upload trên máy',
    uiEnabledHint: 'Hiện hoặc ẩn nút / QR Mobile Upload trên app máy này (Lite & Pro).',
    uiEnabledOn: 'Đang hiện trên máy',
    uiEnabledOff: 'Đang ẩn trên máy',
    uiEnabledSaveSuccess: 'Đã cập nhật hiện/ẩn Mobile Upload',
    uiEnabledSaveError: 'Không cập nhật được hiện/ẩn Mobile Upload',
    uiEnabledLoadError: 'Không tải được trạng thái hiện/ẩn Mobile Upload',
    controlUiTitle: 'Hiện mục Điều khiển cho user',
    controlUiHint: 'Tắt thì ẩn tab Điều khiển trên tài khoản user và mục Điều khiển trong Settings mlite của máy này.',
    controlUiSaveSuccess: 'Đã cập nhật hiện/ẩn Điều khiển',
    controlUiSaveError: 'Không cập nhật được hiện/ẩn Điều khiển',
    controlUiLoadError: 'Không tải được trạng thái Điều khiển',
    bgRemovalTitle: 'Xóa nền (máy này)',
    bgRemovalHint: 'Bật: hiện nút xóa nền AI trên máy Pro này (mặc định tắt) và tab Nền trong chi tiết khung. Tắt: ẩn cả hai.',
    bgRemovalSaveSuccess: 'Đã cập nhật xóa nền cho máy này',
    bgRemovalSaveError: 'Không cập nhật được xóa nền',
    bgRemovalLoadError: 'Không tải được trạng thái xóa nền',
    limitLoadError: 'Không thể tải giới hạn Mobile Upload.',
    limitSaveSuccess: 'Đã lưu giới hạn Mobile Upload.',
    limitSaveError: 'Không thể lưu giới hạn.',
    accessInvalid: 'Vui lòng nhập số nguyên từ 0 đến 9999.',
    printCopiesInvalid: 'Số bản in tối đa phải từ 1 đến 10.',
    restartApp: 'Reset',
    shutdownApp: 'Tắt app',
    restartConfirmTitle: 'Khởi động lại app?',
    restartConfirmBody: 'App trên máy sẽ khởi động lại (giống khi rút camera). Tiếp tục?',
    shutdownConfirmTitle: 'Tắt app?',
    shutdownConfirmBody: 'App trên máy sẽ đóng hoàn toàn. Tiếp tục?',
    restartSent: 'Đã gửi lệnh Reset xuống máy',
    shutdownSent: 'Đã gửi lệnh tắt app xuống máy',
    appOfflineCantRemote: 'Máy đang offline — hãy mở app trước',
    confirmAction: 'Xác nhận',
  },
  icons: {
    dropActive: 'Thả file icon PNG vào đây',
    dropIdle: 'Kéo thả icon PNG vào đây, hoặc click để chọn',
    hint: 'Chỉ nhận PNG, tối đa 30 file/lần. File trên 500KB sẽ tự nén khi upload.',
  },
};

const ko: PagesMessages = {
  common: {
    cancel: '취소',
    save: '저장',
    view: '보기',
    loading: '로딩 중...',
    delete: '삭제',
    edit: '수정',
    refresh: '새로고침',
    close: '닫기',
    all: '전체',
    newest: '최신순',
    oldest: '오래된순',
    newestShort: '최신',
    oldestShort: '오래된',
    fromDate: '시작일',
    toDate: '종료일',
    sortBy: '정렬',
    updating: '업데이트 중...',
    saving: '저장 중...',
    update: '업데이트',
    create: '만들기',
    add: '추가',
    copy: '복사',
    purgedOldGalleries: '1년 이상 된 갤러리 {n}개를 삭제했습니다',
  },
  mPhotoPro: {
    title: 'M-Photo Pro',
    subtitle: 'Pro 데스크톱 앱용 갤러리 및 커스텀 프레임',
    noAccess: '이 계정에는 M-Photo Pro 접근 권한이 없습니다.',
    tabs: { photos: '사진', customFrames: '커스텀 프레임', customFramesShort: '프레임', themes: '테마', themesShort: '테마', collections: '컬렉션', icons: '아이콘', stats: '통계' },
  },
  colorApps: {
    title: '앱 색상',
    titleAll: '앱 색상 — 모든 기기',
    titleMachine: '앱 색상 — 이 기기',
    description:
      '대표 색을 선택하세요 — 앱은 기기에서와 같이 밝은 팔레트(배경, 테두리, soft…)를 사용합니다.',
    descriptionAll:
      '이 계정의 모든 기기 앱 강조 색을 변경합니다. 기기별 Color Apps 탭에서 개별 색도 설정할 수 있습니다.',
    descriptionMachine:
      '이 기기만 앱 강조 색을 변경합니다. 계정의 다른 기기는 각자 색을 유지합니다.',
    hexLabel: '색상 코드 (hex)',
    pickColor: '색 선택',
    hexHelper: '예: #d45d7f — Enter 또는 적용을 눌러 저장',
    apply: '적용',
    presets: '추천 색상',
    derivedPalette: '앱에서 쓰는 색상 팔레트 (Derived palette)',
    preview: 'UI 미리보기',
    primaryBtn: '기본 버튼',
    secondaryBtn: '보조 버튼',
    badgeChip: '배지 / 칩',
    loadError: '앱 색상을 불러오지 못했습니다',
    saveSuccess: '앱 색상이 저장되었습니다',
    saveSuccessAll: '모든 기기에 앱 색상이 저장되었습니다',
    saveSuccessMachine: '이 기기에 앱 색상이 저장되었습니다',
    saveError: '색상 저장에 실패했습니다',
    invalidHex: '잘못된 색상 코드 (#RRGGBB)',
    slots: {
      bg: '배경',
      surface: '서피스',
      border: '테두리',
      soft: '소프트',
      primary: '프라이머리',
      hover: '호버',
      text: '텍스트',
    },
  },
  photoboothSimple: {
    title: 'Photobooth',
    titleMachine: 'Photobooth',
    descriptionMachine: '켜면 이 기기에 촬영 QR이 표시됩니다.',
    toggleLabel: '심플 모드',
    toggleOnHint: '켜짐',
    toggleOffHint: '꺼짐',
    maxAccessLabel: '일일 인쇄 횟수',
    maxAccessHint: '0 = 제한 없음',
    maxAccessSaveSuccess: '기기별 일일 제한이 업데이트되었습니다',
    captureIdleLabel: '촬영 화면 대기 시간',
    captureIdleHint: '촬영 화면에서 조작이 없으면 홈으로 돌아갑니다 (1–10분)',
    previewIdleLabel: '미리보기 대기 시간',
    previewIdleHint: '미리보기에서 조작이 없으면 자동 인쇄 / 홈 복귀 (1–10분)',
    retakeToggleLabel: 'Simple HTML 재촬영 버튼 표시',
    retakeToggleHint: '인쇄 전에 손님이 개별 슬롯을 다시 찍을 수 있습니다',
    retakeEnableSuccess: 'Simple HTML 재촬영 버튼이 켜졌습니다',
    retakeDisableSuccess: 'Simple HTML 재촬영 버튼이 숨겨졌습니다',
    idleTimeoutSaveSuccess: '대기 시간이 업데이트되었습니다',
    idleTimeoutUnit: '분',
    captureCountdownLabel: '촬영 카운트다운',
    captureCountdownHint: '촬영 전 카운트다운 초 (1–30). +/− 누르면 기기에 바로 적용됩니다. Control Page와 같고 서버에 저장되지 않습니다.',
    captureCountdownUnit: '초',
    captureCountdownSaveSuccess: '카운트다운을 기기로 전송했습니다',
    captureCountdownOffline: '기기가 오프라인입니다 — 앱을 연결한 뒤 변경하세요',
    lastUpdated: '마지막 업데이트: {date}',
    loadError: 'Photobooth Simple 모드를 불러오지 못했습니다',
    enableSuccess: '이 기기에 심플 모드가 켜졌습니다',
    disableSuccess: '이 기기에 심플 모드가 꺼졌습니다',
    saveError: '심플 모드 업데이트에 실패했습니다',
    missingMachine: '기기 코드가 없습니다',
    accessCodeTitle: '접속 코드 (3자)',
    accessCodeHint: '손님은 QR 링크를 연 뒤 이 코드를 입력합니다. 대기 중에는 3분마다 코드가 변경됩니다.',
    accessCodeUpdated: '코드 업데이트: {date}',
    sessionInUse: '현재 다른 사용자가 이 photobooth 세션을 사용 중입니다.',
    qrTitle: '촬영 접속 QR',
    qrHint: '이 기기의 photobooth 페이지를 엽니다 (접속 코드 입력 필요).',
    copyLink: '링크 복사',
    openLink: '링크 열기',
  },
  mPhotoLite: {
    title: 'M-Photo Lite',
    subtitle: 'Android 앱용 갤러리 서버, 커스텀 프레임 및 PNG 아이콘',
    tabs: { gallery: '사진', customFrames: '커스텀 프레임', customFramesShort: '프레임', themes: '테마', themesShort: '테마', icons: '아이콘', stats: '통계' },
    galleryEmpty: 'M-Photo Lite 갤러리가 아직 없습니다.',
    iconsDisabled: 'Device Management가 꺼져 있어 아이콘을 관리할 수 없습니다.',
  },
  mPhotoMono: {
    title: 'M-Photo Mono',
    tabs: { subPhotos: '보조 사진', frames: '프레임 추가', photos: '사진', stats: '통계' },
    dropActive: '여기에 사진을 놓으세요',
    dropIdle: '사진을 드래그하거나 클릭하여 선택',
    photosHint: 'Mono 앱에서 서버로 동기화된 갤러리 목록입니다.',
    totalFiltered: '필터에 맞는 갤러리 {n}개',
    total: '총 갤러리 {n}개',
    photoCount: '사진 {n}장 · 인쇄 {p}회',
    endOfList: '전체 {shown}/{total} 갤러리 표시됨',
    emptyFiltered: '필터에 맞는 갤러리가 없습니다',
    empty: 'M-Photo Mono 갤러리가 아직 없습니다',
  },
  photos: {
    viewTabs: { groups: '그룹', list: '목록', collections: '컬렉션' },
    selectAll: '전체 선택',
    downloadSelected: '다운로드 ({n}개 그룹)',
    downloading: '다운로드 중...',
    addToCollection: '컬렉션에 추가',
    dropActive: '여기에 사진을 놓으세요',
    dropIdle: '사진을 드래그하거나 클릭하여 선택',
    maxFiles: '한 번에 최대 10장',
    uploadCta: '사진 추가',
    filterByDate: '날짜 필터',
    filterByDevice: '기기',
    allDevices: '모든 기기',
    clearFilter: '초기화',
  },
  customFrames: {
    titlePro: '커스텀 프레임 — M-Photo Pro',
    titleLite: '커스텀 프레임 — M-Photo Lite',
    titleMono: '커스텀 프레임 — M-Photo Mono',
    hintPro: '관리자가 M-Photo Pro 앱에 켠 프레임입니다.',
    hintLite: '관리자가 M-Photo Lite에 켠 프레임입니다.',
    emptyGranted: '관리자가 아직 커스텀 프레임을 허용하지 않았습니다.',
    emptyEnabled: '관리자가 아직 커스텀 프레임을 켜지 않았습니다.',
    filterSize: '크기 필터',
    viewUserFrames: '사용자 프레임 보기',
    toggleOn: '켜짐 — 끄려면 탭',
    toggleOff: '꺼짐 — 켜려면 탭',
  },
  livePhotos: {
    title: '라이브 포토',
    loginRequired: '컬렉션을 선택하고 라이브 보기를 하려면 로그인하세요.',
    emptyCollections: '아직 컬렉션이 없습니다.',
    selectCollection: '왼쪽에서 컬렉션을 선택해 라이브 보기를 시작하세요.',
    emptyGallery: '이 컬렉션에는 아직 갤러리가 없습니다.',
    galleryLabel: '갤러리:',
    uploadedAt: '업로드: {datetime}',
    collectionListTitle: '컬렉션 목록',
    galleryListTitle: '갤러리 목록',
  },
  videos: {
    title: '내 동영상',
    dropActive: '여기에 동영상을 놓으세요',
    dropIdle: '동영상을 드래그하거나 클릭하여 선택',
    maxOne: '한 번에 최대 1개',
    created: '생성일: {date}',
  },
  sePay: {
    title: 'SePay 결제',
    subtitle: '결제 게이트웨이 및 인쇄 가격 설정',
    tabs: { config: 'SePay 설정', price: '4×6 인쇄 가격', device: '기기' },
    webhookTitle: 'Webhook URL',
    webhookHint: 'SePay Dashboard → Webhooks → 새 웹훅 만들기에 붙여넣으세요',
    receivingAccount: '입금 계좌',
    linked: '연결됨 — 탭하여 변경',
    noAccount: '선택된 계좌 없음',
    tapToConfig: '탭하여 설정',
    saveKeysHeading: 'SePay 게이트웨이 키 저장',
    apiTokenLabel: 'API Token',
    priceLabel: '4×6 1장 가격 (VND)',
    savePrice: '가격 저장',
    clearInput: '입력 지우기',
    deviceHeading: '기기별 Device Management',
    deviceHint: '"SePay QR 필수"를 켜면 인쇄 전 QR 스캔이 필요합니다.',
    liteRequireQr: 'M-Photo Lite — SePay QR 필수',
    proRequireQr: 'M-Photo Pro — SePay QR 필수',
    createQrTitle: '결제 QR 생성 (VietQR)',
    amount: '금액 (VND)',
    description: '설명',
    bank: '은행',
    va: '가상계좌 (VA) *',
    passwordDialog: '비밀번호 확인',
    qrDialog: 'QR을 스캔하여 이체',
  },
  events: {
    title: '이벤트 관리',
    createNew: '새 이벤트 만들기',
    empty: '아직 이벤트가 없습니다. 첫 이벤트를 만들어 보세요!',
    code: '코드: {code}',
    dialogCreate: '새 이벤트 만들기',
    dialogUpdate: '이벤트 업데이트',
    nameLabel: '이벤트 이름',
    namePlaceholder: '예: 2025 설날 이벤트',
    submitCreate: '만들기',
    submitUpdate: '업데이트',
    confirmDelete: '이벤트 "{name}"을(를) 삭제하시겠습니까?',
  },
  profile: {
    title: '개인 정보',
    loading: '사용자 정보를 불러오는 중...',
    changeBackground: '배경 변경',
    changeAvatar: '아바타 변경',
    basicInfo: '기본 정보',
    username: '사용자 이름',
    email: '이메일',
    passwordSection: '비밀번호 변경 (선택)',
    currentPassword: '현재 비밀번호',
    newPassword: '새 비밀번호',
    confirmPassword: '새 비밀번호 확인',
    submit: '정보 업데이트',
    submitting: '업데이트 중...',
  },
  themes: {
    title: '테마 관리',
    createNew: '새 테마 만들기',
    customFrameList: '커스텀 프레임 목록',
    proShowAllTitle: '모든 커스텀 프레임 표시 (M-Photo Pro)',
    proShowAllHint: '켜기: Pro 기기가 모든 레이아웃 표시. 끄기: 활성 테마의 레이아웃만 표시.',
    emptyTitle: '테마가 아직 없습니다',
    emptyHint: 'M-Photo Pro용 첫 테마를 만드세요.',
    emptyHintLite: 'M-Photo Lite 전용 테마를 만드세요 — Pro와 별도입니다.',
    active: '활성',
    inactive: '비활성',
    activeMliteLabel: 'Lite 촬영 (mlite)',
    mobileUploadProTitle: '모바일 업로드 (Pro)',
    mobileUploadProHint: 'Lite와 별도 — Pro에서 HTML 모바일 업로드 시에만.',
    mobileUploadLiteTitle: '모바일 업로드 (Lite)',
    mobileUploadLiteHint: 'Pro와 별도 — Lite에서 HTML 모바일 업로드 시에만.',
    mobileUploadOtherStatus: '다른 채널: {status}',
    scheduleOpen: '설정',
    scheduleTitle: '설정',
    scheduleHint: '켜면 테마는 선택한 시작과 종료 시간 사이에만 적용됩니다.',
    scheduleEnable: '지정한 시간에만 사용',
    scheduleFrom: '시작',
    scheduleUntil: '종료',
    machineFilterEnable: 'Pro 기기',
    machineFilterEnableLite: 'Android 기기',
    machineFilterSelectAll: '전체 선택',
    machineFilterClearAll: '전체 해제',
    machineFilterHint: '체크한 Pro 기기만 적용됩니다. 아무것도 체크하지 않으면 어떤 기기에도 적용되지 않습니다.',
    machineFilterHintLite: '체크한 Android 기기(M-Photo Lite)만 적용됩니다. 아무것도 체크하지 않으면 어떤 기기에도 적용되지 않습니다.',
    machineFilterNeedFrame: '기기를 필터하려면 프레임을 먼저 추가해 주세요.',
    machineFilterEmpty: '이 계정에는 아직 Pro 기기가 없습니다.',
    machineFilterEmptyLite: '이 계정에는 아직 Android 기기가 없습니다.',
    machineFilterLoading: '기기 목록 불러오는 중...',
    machineFilterButton: '기기 필터',
    machineFilterSaved: '기기 필터를 저장했습니다',
    machineFilterSaveFail: '기기 필터를 저장하지 못했습니다',
    scheduleAlways: '항상',
    scheduleAllMachines: '모든 기기',
    scheduleNoMachines: '적용 기기 없음',
    scheduleMachineCount: '기기 {n}대',
    scheduleOutside: '시간 범위 밖',
    dialogCreate: '새 테마 만들기',
    dialogEdit: '테마 업데이트',
    name: '테마 이름',
    description: '설명',
    tags: '태그 (쉼표로 구분)',
    imageOptional: '테마 이미지 (선택)',
    dropImage: '클릭하여 이미지를 선택하거나 여기에 드래그하세요',
    imageFormats: 'PNG, JPG, JPEG (최대 10MB)',
    breadcrumb: '테마',
    noDescription: '설명 없음',
    metaCounts: '커스텀 프레임 {n}개 • 사용자 프레임 {m}개',
    addCustomFrame: '커스텀 프레임 추가',
    framesInTheme: '테마의 커스텀 프레임',
    emptyFramesTitle: '커스텀 프레임이 아직 없습니다',
    emptyFramesHint: '"커스텀 프레임 추가"를 눌러 테마에 프레임을 넣으세요',
    addDialogTitle: '테마에 커스텀 프레임 추가',
    addDialogHint: 'M-Photo Pro용으로 켜진 커스텀 프레임만 표시됩니다.',
    addDialogHintLite: 'M-Photo Lite용으로 켜진 커스텀 프레임만 표시됩니다.',
    noLiteFrames: 'Lite용으로 켜진 커스텀 프레임이 아직 없습니다.',
    pickUserFramesTitle: '사용자 프레임 선택',
    pickUserFramesHint: '이 커스텀 프레임의 사용자 프레임을 골라 테마에 넣습니다.',
    pickUserFramesUpload: '사용자 프레임 업로드',
    pickUserFramesUploadHint: 'PNG, JPG. 최대 10개, 파일당 5MB.',
    pickUserFramesUploading: '사용자 프레임 업로드 중...',
    pickUserFramesEmpty: '이 커스텀 프레임에는 사용자 프레임이 없습니다.',
    pickUserFramesAdd: '사용자 프레임 {n}개 추가',
    pickUserFramesAddFrame: '프레임만 추가',
    searchPlaceholder: '이름 또는 크기로 검색...',
    filterByRatio: '비율로 필터',
    noProFrames: 'Pro용으로 켜진 커스텀 프레임이 아직 없습니다.',
    allAddedOrFiltered: '모든 프레임이 이미 테마에 있거나 필터와 맞지 않습니다',
    notFound: '테마를 찾을 수 없습니다',
  },
  customerInfo: {
    title: '고객 정보',
    subtitle: '고객 정보 및 수집 설정 관리',
    settingTitle: '정보 수집 설정',
    enabled: '켜짐 — 갤러리 조회 시 고객 정보 입력이 필요합니다',
    disabled: '꺼짐 — 갤러리 조회 시 고객 정보 입력이 필요 없습니다',
    listTitle: '고객 목록 ({total})',
    export: '고객 정보 내보내기',
    empty: '고객 정보가 아직 없습니다',
    endMessage: '전체 {total}명 고객 표시됨',
    colImage: '사진',
    colEmail: '이메일',
    colName: '이름',
    colActions: '작업',
    noImage: '사진 없음',
    editDialog: '고객 정보 수정',
    confirmDelete: '이 고객 정보를 삭제하시겠습니까?',
  },
  software: {
    title: '소프트웨어',
    latestVersion: '최신 버전 ({channel})',
    fileName: '파일 이름:',
    fileSize: '크기:',
    uploadDate: '업로드 날짜:',
    download: '다운로드',
    noUpdate: '다운로드할 새 버전이 없습니다',
    updateInfo: '업데이트 정보',
  },
  aiCreate: {
    title: 'AI 이미지 만들기',
    subtitle: '먼저 AI 주제를 만든 다음, 그 안에 배경을 추가하세요.',
    disabled: '이 계정은 AI 이미지 생성이 켜져 있지 않습니다.',
    createTheme: 'AI 주제 만들기',
    viewUsage: '생성 기록',
    usageTheme: '주제',
    usageBackground: '배경',
    editTheme: 'AI 주제 수정',
    themeName: '주제 이름',
    description: '설명',
    themeImage: '주제 이미지',
    noThemes: 'AI 주제가 없습니다. 배경을 추가하기 전에 주제를 만드세요.',
    backgrounds: 'AI 배경',
    backgroundCount: 'AI 배경 {n}개',
    emptyBackgrounds: '이 주제에는 아직 AI 배경이 없습니다.',
    createBackground: 'AI 배경 만들기',
    editBackground: 'AI 배경 수정',
    backgroundName: '배경 이름',
    prompt: '프롬프트',
    tags: '태그',
    tagMale: '남성',
    tagFemale: '여성',
    tagGroup: '그룹',
    tagsRequired: '태그를 하나 이상 선택하세요.',
    image: '이미지',
    referenceImage: '참고 이미지 (선택)',
    referenceHint: '고객 사진이 이미지 1입니다. 이 참고 이미지는 이미지 2입니다.',
    removeReference: '참고 이미지 제거',
    proEnable: 'Pro 기기',
    proHint: 'Pro 기기에서 연 Pro 앱과 모바일 업로드.',
    liteEnable: 'Lite 기기',
    liteHint: 'Lite 기기에서 연 Android 앱과 모바일 업로드.',
    machineHint: '체크한 기기만 보입니다. 아무것도 체크하지 않으면 표시되지 않습니다.',
    noMachines: '이 종류의 기기가 없습니다.',
    back: '뒤로',
    save: '저장',
    cancel: '취소',
    delete: '삭제',
    confirmDeleteTheme: '이 AI 주제와 안의 모든 배경을 삭제할까요?',
    confirmDeleteBackground: '이 AI 배경을 삭제할까요?',
  },
  deviceMgmt: {
    title: '기기 관리',
    subtitle: '기기를 선택해 랜덤 코드를 보고 휴대폰에서 사진을 업로드하세요',
    emptyTitle: '기기가 아직 없습니다',
    emptyHint: 'Device Management를 사용하려면 먼저 기기를 등록하세요',
    machineCode: '기기 코드:',
    running: '작동 중',
    paused: '일시정지',
    platformWindows: 'Windows',
    platformAndroid: 'Android',
    productLite: 'Lite',
    productMono: 'Mono',
    productPro: 'Pro',
    noQrFeatures: 'Mono 기기에는 Mobile Upload / Page Control QR가 없습니다.',
    viewAccess: '접속',
    renameTitle: '기기 이름 변경',
    renameSuccess: '기기 이름이 업데이트되었습니다',
    deleteTitle: '기기 삭제',
    deleteConfirm: '기기 "{code}"를 삭제할까요? 이 작업은 되돌릴 수 없습니다.',
    deleteSuccess: '기기가 삭제되었습니다',
    nameLabel: '기기 이름',
    namePlaceholder: '새 기기 이름 입력',
    back: '기기 목록으로',
    backShort: '뒤로',
    tabs: {
      upload: '모바일 업로드',
      uploadShort: '업로드',
      control: '페이지 제어',
      controlShort: '제어',
      photos: '사진',
      photosShort: '사진',
      edit: '편집 목록',
      editShort: '편집',
      colorApps: '앱 색상',
      colorAppsShort: '색상',
      photobooth: 'Photobooth',
      photoboothShort: 'Booth',
      qrEdit: 'QR 편집',
      qrEditShort: 'QR',
    },
    qrEditor: {
      title: '인쇄 QR 위치',
      hint: '이 기기에서 레이아웃/프레임별로 QR 오프셋과 크기를 조정합니다. mlite와 동기화할 때 더 최근 수정 시각이 적용됩니다.',
      frame: '프레임',
      layoutDefault: '레이아웃 기본값',
      userFrames: '유저 프레임',
      offsetX: 'X 오프셋',
      offsetY: 'Y 오프셋',
      size: 'QR 크기',
      step: '간격',
      showQr: '인쇄 시 QR 표시',
      lastEdited: '마지막 수정: {date}',
      saveSuccess: 'QR 위치가 저장되었습니다',
      saveError: 'QR 위치를 저장하지 못했습니다',
      loadError: 'QR 위치를 불러오지 못했습니다',
      reset: '초기화',
    },
    photosFilteredBy: '기기 {code}로 필터됨',
    photosEmptyTitle: '이 기기의 사진이 없습니다',
    photosEmptyHint: '기기 코드 {code}와 일치하는 갤러리가 없습니다',
    photosEnd: '기기 {code}의 갤러리를 모두 불러왔습니다',
    photosLoadError: '사진을 불러오지 못했습니다',
    photosNoLink: '갤러리 링크를 사용할 수 없습니다',
    photosDeleteTitle: '사진 그룹 삭제',
    photosDeleteConfirm: '이 사진 그룹을 삭제할까요? 이 작업은 되돌릴 수 없습니다.',
    photosDeleteSuccess: '사진 그룹이 삭제되었습니다',
    photosDeleteError: '사진 그룹을 삭제하지 못했습니다',
    machineCodeLabel: '기기 코드',
    randomCodeTitle: '랜덤 코드 (3자)',
    randomCodeHint: '이 코드는 M-Photo Lite 앱에서 3분마다 자동 갱신됩니다',
    lastUpdated: '마지막 업데이트: {date}',
    qrUploadTitle: '사진 업로드용 QR 코드',
    qrUploadHint: '휴대폰으로 이 QR을 스캔해 사진 업로드 페이지를 여세요',
    fullCode: '전체 코드:',
    copyLink: '링크 복사',
    openNewTab: '새 탭에서 열기',
    controlQrTitle: '기기 제어 QR 코드',
    controlQrHint: '휴대폰으로 이 QR을 스캔해 기기 제어 페이지를 여세요',
    editQrTitle: '갤러리 편집 / 서명 QR',
    editQrHint: '이 기기에서 서명·편집 대기 중인 갤러리 목록을 열려면 스캔하세요',
    link: '링크:',
    notFound: '기기 정보를 찾을 수 없습니다',
    limitTitle: '기기별 제한',
    limitHint: '기기당 일일 접속 횟수와 최대 인쇄 매수를 설정하세요. 0은 접속 무제한입니다.',
    accessLabel: '접속 횟수',
    accessHint: '0 = 제한 없음 · 매일 초기화',
    printCopiesLabel: '최대 인쇄 매수',
    printCopiesHint: '기본 1 · 최대 10장 (4×6)',
    uiEnabledTitle: '기기에서 Mobile Upload 표시',
    uiEnabledHint: '이 기기 앱의 Mobile Upload 버튼/QR 표시 여부를 설정합니다 (Lite & Pro).',
    uiEnabledOn: '기기에 표시 중',
    uiEnabledOff: '기기에서 숨김',
    uiEnabledSaveSuccess: 'Mobile Upload 표시 설정이 업데이트되었습니다',
    uiEnabledSaveError: 'Mobile Upload 표시 설정을 저장하지 못했습니다',
    uiEnabledLoadError: 'Mobile Upload 표시 설정을 불러오지 못했습니다',
    controlUiTitle: '사용자에게 제어 메뉴 표시',
    controlUiHint: '끄면 사용자 계정의 제어 탭과 mlite 설정의 제어 항목이 숨겨집니다.',
    controlUiSaveSuccess: '제어 표시 설정이 업데이트되었습니다',
    controlUiSaveError: '제어 표시 설정을 저장하지 못했습니다',
    controlUiLoadError: '제어 표시 설정을 불러오지 못했습니다',
    bgRemovalTitle: '배경 제거 (이 기기)',
    bgRemovalHint: '켜면 이 Pro 기기에 AI 배경 제거 토글(기본 꺼짐)과 프레임 상세의 배경 탭이 표시됩니다. 끄면 둘 다 숨깁니다.',
    bgRemovalSaveSuccess: '이 기기의 배경 제거 설정이 업데이트되었습니다',
    bgRemovalSaveError: '배경 제거 설정을 저장하지 못했습니다',
    bgRemovalLoadError: '배경 제거 설정을 불러오지 못했습니다',
    limitLoadError: 'Mobile Upload 제한을 불러올 수 없습니다.',
    limitSaveSuccess: 'Mobile Upload 제한이 저장되었습니다.',
    limitSaveError: '제한을 저장할 수 없습니다.',
    accessInvalid: '0~9999 사이 정수를 입력하세요.',
    printCopiesInvalid: '최대 인쇄 매수는 1~10이어야 합니다.',
    restartApp: 'Reset',
    shutdownApp: '앱 종료',
    restartConfirmTitle: '앱을 다시 시작할까요?',
    restartConfirmBody: '기기 앱이 다시 시작됩니다 (카메라 분리 시와 동일). 계속할까요?',
    shutdownConfirmTitle: '앱을 종료할까요?',
    shutdownConfirmBody: '기기 앱이 완전히 종료됩니다. 계속할까요?',
    restartSent: '재시작 명령을 기기로 보냈습니다',
    shutdownSent: '종료 명령을 기기로 보냈습니다',
    appOfflineCantRemote: '기기가 오프라인입니다 — 먼저 앱을 실행하세요',
    confirmAction: '확인',
  },
  icons: {
    dropActive: '여기에 PNG 아이콘을 놓으세요',
    dropIdle: 'PNG 아이콘을 드래그하거나 클릭하여 선택',
    hint: 'PNG만, 한 번에 최대 30개. 500KB 초과 파일은 업로드 시 압축됩니다.',
  },
};

export const pagesMessages: Record<AppLang, PagesMessages> = { en, vi, ko, zh: zhPages };
